
(function () {
  const isLocalStorageAvailable = () => {
    try {
      if (
        typeof Storage === "undefined" ||
        typeof localStorage === "undefined"
      ) {
        return false;
      }
      const test = "__localStorage_test__";
      localStorage.setItem(test, test);
      localStorage.removeItem(test);
      return true;
    } catch (e) {
      return false;
    }
  };

  const safeGetItem = (key) => {
    try {
      if (!isLocalStorageAvailable()) {
        return null;
      }
      return localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  };

  const initPopularProducts = (section) => {
    const $section = $(section);

    if ($section.hasClass("slider_started")) {
      return;
    }

    $section.addClass("slider_started");

    let id = $section.attr("id");
    let slideEl = $section.find(".swiper-wrapper");
    let productCount = parseInt(slideEl.data("count"));
    let productCountMobile = parseInt(slideEl.data("count-mobile"));

    let prodSwiperParams = {
      loop: false,
      autoHeight: false,
      allowTouchMove: true,
      slidesPerView: productCount,
      lazy: true,
      preloadImages: false,
      spaceBetween: 24,
      navigation: {
        nextEl: `#${id} .swiper-button-next`,
        prevEl: `#${id} .swiper-button-prev`,
      },
      watchSlidesProgress: true,
      preventInteractionOnTransition: true,
      mousewheel: {
        forceToAxis: true,
      },
    };

    let swiper = new Swiper(
      `#${id} .product-carousel-swiper`,
      prodSwiperParams
    );

    swiper.on("resize", function () {
      const w = window.innerWidth;

      if (productCount === 6) {
        this.params.slidesPerView =
          w < 576 ? productCountMobile :
          w < 750 ? 2 :
          w < 1100 ? 3 :
          w < 1360 ? 4 :
          w < 1600 ? 5 : 6;
      } else if (productCount === 5) {
        this.params.slidesPerView =
          w < 576 ? productCountMobile :
          w < 750 ? 2 :
          w < 1100 ? 3 :
          w < 1360 ? 4 : 5;
      } else if (productCount === 4) {
        this.params.slidesPerView =
          w < 576 ? productCountMobile :
          w < 750 ? 2 :
          w < 1100 ? 3 : 4;
      } else if (productCount === 3) {
        this.params.slidesPerView =
          w < 576 ? productCountMobile :
          w < 750 ? 2 : 3;
      } else if (productCount === 2) {
        this.params.slidesPerView =
          w < 576 ? productCountMobile : 2;
      }
    });
  };

  const initSection = async (section, retryCount = 0) => {
    if (
      !section ||
      !section.classList.contains("recently-viewed-section")
    ) {
      return;
    }

    const box = section.querySelector(".recently-viewed");
    if (!box) return;

    const showSection = () => {
      section.style.display = "";
      box.classList.remove("recently-viewed--empty");
      box.classList.add("recently-viewed--has-products");
    };

    const hideSection = () => {
      box.classList.remove("recently-viewed--has-products");
      box.classList.add("recently-viewed--empty");
      box.classList.remove("recently-viewed--loading");
      section.style.display = "none";
    };

    const hasProductsInDOM = box.querySelector(
      ".popular-products__grid .popular-products__item"
    );

    if (
      box.classList.contains("recently-viewed--has-products") &&
      hasProductsInDOM
    ) {
      showSection();
      box.classList.remove("recently-viewed--loading");

      setTimeout(() => {
        initPopularProducts(section);
      }, 50);

      try {
        colorSwatches();
      } catch (err) {
        // Ignore color swatches error
      }
      return;
    }

    const STORAGE_KEY = "__sf_theme_recently";
    const EXPIRATION_DAYS = box.dataset.expirationDays
      ? Number(box.dataset.expirationDays)
      : 30;
    const dateNow = Date.now();

    const baseUrl = box.dataset.baseUrl;
    const productsLimit = Number(box.dataset.productsLimit) || 6;
    const currentPageProductId = box.dataset.currentPageProductId;

    let recentProducts = [];

    try {
      const stored = safeGetItem(STORAGE_KEY);
      if (stored) {
        const parsed = JSON.parse(stored);
        recentProducts = Array.isArray(parsed) ? parsed : [];
      }
    } catch (e) {
      recentProducts = [];
    }

    if (currentPageProductId) {
      recentProducts = recentProducts.filter(
        (item) => String(item.productId) !== String(currentPageProductId)
      );
    }

    if (
      recentProducts.length === 0 &&
      currentPageProductId &&
      retryCount < 2
    ) {
      setTimeout(() => {
        initSection(section, retryCount + 1);
      }, 100);
      return;
    }

    if (recentProducts.length === 0) {
      hideSection();
      return;
    }

    const expirationTime =
      EXPIRATION_DAYS * 24 * 60 * 60 * 1000;

    const validProducts = recentProducts.filter(
      (item) =>
        item &&
        item.productId &&
        dateNow - item.timestamp < expirationTime
    );

    const limitedProducts = validProducts.slice(0, productsLimit);

    if (limitedProducts.length === 0) {
      hideSection();
      return;
    }

    const query = limitedProducts
      .map((item) => `id:${item.productId}`)
      .join("%20OR%20");

    if (!query.trim()) {
      hideSection();
      return;
    }

    const url = `${baseUrl}&q=${query}`;

    try {
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error("Recently viewed request failed");
      }

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const sourceBox = doc.querySelector(".recently-viewed");

      if (
        !sourceBox ||
        !sourceBox.classList.contains(
          "recently-viewed--search-perfomed"
        )
      ) {
        hideSection();
        return;
      }

      const loadedProducts = sourceBox.querySelectorAll(
        ".popular-products__grid .popular-products__item"
      );

      if (loadedProducts.length === 0) {
        hideSection();
        return;
      }

      box.innerHTML = sourceBox.innerHTML;

      showSection();

      box.classList.remove("recently-viewed--loading");

      initPopularProducts(section);

      try {
        colorSwatches();
      } catch (err) {
        // Ignore color swatches error
      }
    } catch (error) {
      hideSection();
    } finally {
      box.classList.remove("recently-viewed--loading");
    }
  };

  const initializeSection = () => {
    const section = document.querySelector(
      ".recently-viewed-section"
    );

    if (section) {
      initSection(section);
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initializeSection
    );
  } else {
    setTimeout(initializeSection, 0);
  }

  document.addEventListener(
    "shopify:section:load",
    function (event) {
      initSection(event.target);
    }
  );

  document.addEventListener(
    "shopify:section:select",
    function (event) {
      const section = event.target;

      if (
        section &&
        section.classList.contains("recently-viewed-section")
      ) {
        initSection(section);
      }
    }
  );

  if (isLocalStorageAvailable()) {
    try {
      window.addEventListener("storage", function (event) {
        if (event.key === "__sf_theme_recently") {
          const section = document.querySelector(
            ".recently-viewed-section"
          );

          if (section) {
            initSection(section);
          }
        }
      });
    } catch (e) {
      // Storage listener not available
    }
  }

  document.addEventListener(
    "recentlyViewedUpdated",
    function () {
      const section = document.querySelector(
        ".recently-viewed-section"
      );

      if (section) {
        initSection(section);
      }
    }
  );
})();
